import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-board-dateview',
    templateUrl: './order-board-dateview.component.html',
    styleUrls: ['./order-board-dateview.component.scss']
})
export class OrderBoardDateviewComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
